<template>
  <div>
    <!-- toasts message -->
        <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="confirmModel" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="confirmModel = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->
 
    <typeForm :formSchema="formSchema" v-on:emitCloseModal="close"></typeForm>

    <v-card-title>
      <h2> Prior Review Thresholds </h2>  
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>

    <v-data-table
      v-bind:headers="headers"
      v-bind:items="items"
      v-bind:search="search"
      v-bind:pagination.sync="pagination"
      :total-items="totalItems"
      :loading="loading"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ ++(props.index) }}</td>
        <td class="text-xs-left">{{ props.item.version_no }}</td>
        <td class="text-xs-left">{{ props.item.type }}</td>
        <td class="text-xs-left">{{ props.item.method }}</td>
        <td class="text-xs-left">{{ props.item.cost }}</td>
        <td class="text-xs-left">{{ props.item.remark }}</td>
        <td>
          <span v-if="props.item.is_active" class="active">Yes</span>
          <span v-else class="in-active">No</span>
        </td>

        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0"  @click="editItem(props.index, props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <!-- <v-btn icon class="mx-0"  @click="deleteItem(props.index, props.item.id)">
            <v-icon color="pink">delete</v-icon>
          </v-btn> -->
        </td>
      </template>

      <template slot="no-data" class="error">
       <div align="center"> No Data Found</div>
    </template>
    </v-data-table>

<!-- {{items}} -->
  </div>
</template>

<script>
let commonService = require("../../../services/common.service");

import typeForm from "./thresholds_form.vue";
export default {
  components: {
    typeForm
  },

  data: () => ({
    dialog: false,
    totalItems: 0,
    loading: true,
    pagination: {
      sortBy: "id",
      descending: true
    },
    search: "",

    headers: [
      {
        text: "SL",
        align: "left",
        sortable: true,
        value: "id"
      },
      {
        text: "Version No",
        align: "left",
        value: "type"
      },
      {
        text: "Type of Procurement",
        align: "left",
        value: "type"
      },
      {
        text: "Procurement Method",
        align: "left",
        value: "method"
      },
      {
        text: "Prior Review Thresholds (Estimated Cost Of The)",
        align: "left",
        value: "cost"
      },
      {
        text: "Remarks",
        align: "left",
        value: "remark"
      },
      {
        text: "Active",
        value: "is_active"
      },
      {
        text: "Action",
        align: "center",
        value: ""
      }
    ],

    items: [],

    delete_id: "",
    row_index: "",
    confirmModel: false,
    snackbar: false,
    color: "success",
    mode: "",
    timeout: 3000,
    left: "left",
    message: "",

    leaveTypeModal: false,
    formSchema: {
      id: "",
      version_no:'',
      type: "",
      method: "",
      cost: "",
      remark: "",
      is_active: ""
    },

    queryData: {
      sortBy: "id",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      search_val: ""
    },
     SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },
  }),

  computed: {
    userRole() {
      return this.$store.getters.get_USER_ROLE_DATA;
    }
  },

  mounted() {
    this.loadData();
    this.message = "Data loading!";
    this.snackbar = true;
  },

  methods: {
    loadData(pagination) {
      commonService.getAllData("thresholds").then(res => {
        this.items = res.data;
        this.loading = false;
      });
    },

    editItem(id, data) {
      this.formSchema = data;
      this.leaveTypeModal = true;
      window.scrollTo({
        // scroling to top
        top: 0,
        left: 100,
        behavior: "smooth",
      });
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.confirmModel = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "proc_types").then(res => {
        if (res.status == 1) {
          this.items.splice(row_index, 1);
          this.SnackbarVal.color = "success";
          this.loadData()
          } else {
          this.SnackbarVal.color = "error";
          }
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;

        this.confirmModel = false;
        this.dialog2 = false;
      });
    },

    close(res) {
      let $this = this;
      this.loadData();
      this.SnackbarVal.color = "success";
      this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/procurement/thresholds/thresholds_list.vue